import { SchoolAccessLevel } from "./SchoolAccessRecord";
import { IDropdownOption } from "office-ui-fabric-react/lib-commonjs";
import * as _ from "lodash";

const licenseOptions: License[] = ["unlicensed", "foundation", "silver", "gold", "platinum"];
export const LICENSE_DROPDOWN_OPTIONS = licenseOptions.map((license): IDropdownOption => {
    return {
        key: license,
        text: _.capitalize(license),
        data: license
    };
});
export type License = "unknown" | "unlicensed" | "foundation" | "silver" | "gold" | "platinum";
const licenseLevelsNumeric: { [key: string]: number } = {
    "unknown": -1,
    "unlicensed": 0,
    "foundation": 10,
    "silver": 20,
    "gold": 30,
    "platinum": 40
};
export const licenseLevelIsAtLeast = (first: License = "unknown", second: License = "unknown") => {
    return licenseLevelsNumeric[first] >= licenseLevelsNumeric[second];
}
export const licenseLevelIsLessThan = (first: License = "unknown", second: License = "unknown") => {
    return licenseLevelsNumeric[first] < licenseLevelsNumeric[second];
}

export type OnboardStatus = "notStarted" | "started" | "sdsDataAvailable" | "consultancy" | "completed";

const statuses: OnboardStatus[] = ["notStarted" , "started" , "sdsDataAvailable","consultancy" , "completed"];
export const ONBOARD_STATUS_DROPDOWN_OPTIONS = statuses.map((status: OnboardStatus): IDropdownOption => {
    return {
        text: status,
        key: status,
        data: status
    };
});

export default interface School{
    tenantId?: string;
    schoolCode?: string;

    tenantName?: string;
    schoolName?: string;
    license?: License;
    licenseEndDate?: string;
    licenseReference?: string;

    clientId?: string;
    sdsSchoolId?: string;

    onboardStatus?: OnboardStatus;
    isOnboarding?: boolean;

    disabled?: boolean;
    lastDisabledOn?: Date;

    thirdPartySDS?: boolean;

    [key: string]: any;
}

export interface SchoolRef {
    tenantId: string;
    schoolCode: string;
    tenantName: string;
}

export interface SchoolWithAccessLevel {
    school: School;
    level: SchoolAccessLevel;
}